export const APP_DOCUMENT_TITLE = 'Nodon';
export const PROJECT_LIST_DOCUMENT_TITLE = 'Projects';
const MAX_PROJECT_NAME_LENGTH = 50;

type BuildDocumentTitleOptions = {
  isProjectList: boolean;
  projectName?: string;
  isLoadingProject: boolean;
};

/**
 * Truncate long context text so browser tabs stay readable.
 */
export const truncateDocumentTitleContext = (
  text: string,
  maxLength: number,
): string => {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1)}…`;
};

const formatDocumentTitle = (context: string): string =>
  `${context} – ${APP_DOCUMENT_TITLE}`;

/**
 * Build the browser tab title for the main app shell.
 */
export const buildDocumentTitle = ({
  isProjectList,
  projectName,
  isLoadingProject,
}: BuildDocumentTitleOptions): string => {
  if (isProjectList) {
    return formatDocumentTitle(PROJECT_LIST_DOCUMENT_TITLE);
  }

  if (isLoadingProject) {
    return formatDocumentTitle('Loading…');
  }

  const trimmedName = projectName?.trim() ?? '';
  if (!trimmedName) {
    return APP_DOCUMENT_TITLE;
  }

  const name = truncateDocumentTitleContext(
    trimmedName,
    MAX_PROJECT_NAME_LENGTH,
  );
  return formatDocumentTitle(name);
};
